import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const deleteInvitation = async ({
  organisationId,
  invitationId,
}: {
  organisationId: string;
  invitationId: string;
}): Promise<void> => {
  const response = await axiosClient.delete(
    `${organisationId}/invitations/${invitationId}`,
  );
  return response.data;
};

export function useDeleteInvitation(
  queryOptions?: UseMutationOptions<void, HttpError, { invitationId: string }>,
) {
  const { organisation } = useOrganisation();
  return useMutation({
    mutationFn: ({ invitationId }) =>
      deleteInvitation({ organisationId: organisation.id, invitationId }),
    ...queryOptions,
  });
}
